import React from 'react';

import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin';
import Checkbox from '../../../../components/forms/Checkbox';

const createReactClass = require('create-react-class');

const ShareModalDrawerEmbed = createReactClass({
  getInitialState() {
    return {
      successfulCopy: false,
      noScrollZoom: false,
      hideElevation: false,
      hideName: false,
      showCustomization: false
    };
  },
  formatHtmlToCopy() {
    const iframeSrc = this.formatIframeSrc();
    return `<iframe class="alltrails" src="${iframeSrc}" width="100%" height="400" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" title="AllTrails: Trail Guides and Maps for Hiking, Camping, and Running"></iframe>`;
  },
  formatIframeSrc() {
    let type;
    switch (this.props.shareObject.type) {
      case 'track':
        type = 'recording/';
        break;
      case 'area':
      case 'country':
      case 'state':
      case 'city':
      case 'trail':
        type = '';
        break;
      default:
        type = `${this.props.shareObject.type}/`;
    }

    let urlBase = `${location.protocol}//${location.host}`;
    const queryStrings = [];
    if (this.state.noScrollZoom) {
      queryStrings.push('scrollZoom=false');
    }
    if (this.state.hideElevation) {
      queryStrings.push('elevationDiagram=false');
    }
    if (this.state.hideName) {
      queryStrings.push('hideName=true');
    }
    if (this.props.currentUser) {
      queryStrings.push(`u=${this.props.currentUser.metric ? 'm' : 'i'}`);
    }
    if(this.props.locale && this.props.locale !== 'en') {
      urlBase = `${urlBase}/${this.props.locale}`;
    }

    const queryString = queryStrings.length > 0 ? `?${queryStrings.join('&')}` : '';
    return `${urlBase}/widget/${type}${this.props.shareObject.slug}${queryString}`;
  },
  clickNoScrollZoom() {
    this.setState({
      successfulCopy: false,
      noScrollZoom: !this.state.noScrollZoom
    });
  },
  clickHideElevation() {
    this.setState({
      successfulCopy: false,
      hideElevation: !this.state.hideElevation
    });
  },
  clickHideName() {
    this.setState({
      successfulCopy: false,
      hideName: !this.state.hideName
    });
  },
  copyHtml() {
    const htmlToCopy = this.formatHtmlToCopy();
    this.props.clipboard.writeText(htmlToCopy).then(
      function() {
        this.setState({ successfulCopy: true });
        _gaq.push(['_trackEvent', 'Share', 'embed-copy', this.props.shareObject.type]);
      }.bind(this),
      function(err) {
        console.error('Could not copy text: ', err);
      }
    );
  },
  toggleCustomization() {
    const showCustomization = !this.state.showCustomization;
    this.setState({
      showCustomization
    });
  },
  render() {
    const htmlToCopy = this.formatHtmlToCopy();
    const iframeSrc = this.formatIframeSrc();
    const copyButtonLabel = this.state.successfulCopy
      ? StringConstantsMixin.strings.SHARE_MODAL.HTML_COPIED
      : StringConstantsMixin.strings.SHARE_MODAL.COPY_HTML;
    const copyHtmlButton = this.props.clipboard ? (
      <button className="copy-html" onClick={this.copyHtml}>
        {copyButtonLabel}
      </button>
    ) : null;
    const indicator = (
      <img
        src="https://cdn-assets.alltrails.com/assets/icons/chevron-indicator-small@2x.png"
        className={this.state.showCustomization ? 'indicator expanded' : 'indicator collapsed'}
      />
    );
    let hideNameGroup = null;
    if (this.props.shareObject.ugc) {
      hideNameGroup = (
        <div className="checkbox-group">
          <div className="checkbox-holder">
            <Checkbox
              name="hideName"
              checked={this.state.hideName}
              handleChange={this.clickHideName}
              label={StringConstantsMixin.strings.SHARE_MODAL.HIDE_YOUR_NAME}
            />
          </div>
        </div>
      );
    }
    return (
      <div>
        <div className="form-holder">
          <p className="intro-text">{StringConstantsMixin.strings.SHARE_MODAL.TO_ADD_THIS_TRAIL_TO_YOUR_WEBSITE}</p>
          <textarea readOnly value={htmlToCopy} />
          <div className="customize-form">
            {copyHtmlButton}
            <p className="form-header" onClick={this.toggleCustomization}>
              {StringConstantsMixin.strings.SHARE_MODAL.CUSTOMIZE_YOUR_CODE} {indicator}
            </p>
            <div className={`customization-holder ${this.state.showCustomization ? '' : 'hidden'}`}>
              <div className="checkbox-group">
                <div className="checkbox-holder">
                  <Checkbox
                    name="noScrollZoom"
                    checked={this.state.noScrollZoom}
                    handleChange={this.clickNoScrollZoom}
                    label={StringConstantsMixin.strings.SHARE_MODAL.DEACTIVATE_MOUSE_ZOOM}
                  />
                </div>
                <div className="checkbox-holder">
                  <Checkbox
                    name="hideElevation"
                    checked={this.state.hideElevation}
                    handleChange={this.clickHideElevation}
                    label={StringConstantsMixin.strings.SHARE_MODAL.HIDE_ELEVATION_GRAPH}
                  />
                </div>
              </div>
              {hideNameGroup}
            </div>
          </div>
        </div>
        <div className="preview">
          <p className="preview-title">{StringConstantsMixin.strings.SHARE_MODAL.PREVIEW}</p>
          <iframe src={iframeSrc} scrolling="no" />
        </div>
      </div>
    );
  }
});

export { ShareModalDrawerEmbed };
